import { trackEvent } from '@/lib/telemetry';

const CONSENT_KEY = 'streamko.consent';

/** Non-essential analytics only fire after explicit consent (FR-034). */
function hasAnalyticsConsent(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const raw = window.localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw).analytics === true : false;
  } catch {
    return false;
  }
}

/**
 * Consent-gated landing analytics. Delegates to the shared telemetry layer
 * (`src/lib/telemetry.ts`), which is being migrated from Application Insights
 * to OTLP/OpenTelemetry (constitution §VII). Never throws — analytics must not
 * break the page.
 */
export function track(event: string, props?: Record<string, string>): void {
  if (!hasAnalyticsConsent()) return;
  try {
    trackEvent(event, props);
  } catch {
    /* swallow — telemetry must never block the UI */
  }
}
